__turbopack_context__.v({
  "buttonsContainer": "library-and-store-links-module-scss-module__J-41_q__buttonsContainer",
  "container": "library-and-store-links-module-scss-module__J-41_q__container",
  "printStatusMessage": "library-and-store-links-module-scss-module__J-41_q__printStatusMessage",
  "select": "library-and-store-links-module-scss-module__J-41_q__select",
});
